import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

applyPreferredTheme();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));

function applyPreferredTheme(): void {
  const preferredTheme = readStoredTheme();
  if (preferredTheme === 'light' || preferredTheme === 'dark' || preferredTheme === 'eink') {
    document.documentElement.dataset['theme'] = preferredTheme;
  }
}

function readStoredTheme(): string | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  try {
    return localStorage.getItem('preferred-theme');
  } catch (error) {
    console.warn('Reading preferred theme from storage failed.', error);
    return null;
  }
}
